/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/**
 * ClickOff Directive.
 *
 * Detects clicks outside of an element and its children and runs a method and
 * optional arguments.
 *
 * Syntax: v-click-off="{ method: close, args: [0] }"
 */
const clickOffDirective = {
    bind: function (el, binding) {
        el.offClick = (e) => offClick(e, el, binding);
        document.addEventListener('click', el.offClick);
    },
    unbind: function (el) {
        document.removeEventListener('click', el.offClick);
    },
};
export const offClick = (e, el, binding) => {
    if (!(el === e.target || el.contains(e.target))) {
        binding.value.method(...binding.value.args);
    }
};
export default clickOffDirective;
